

export const baseURL = process.env.REACT_APP_API_BASE_URL || "http://localhost/stellaris_Original/stellaris_php-main/";

export const default_image = `${baseURL}images/common/default.png`;
